<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">角色名：</span>
        </div>
        <el-input v-model="formData.name" :maxlength="32" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">角色权限：</span>
        </div>
        <el-select v-model="shortNameList" multiple placeholder="请选择" size="mini" style="width: 280px">
          <el-option
            v-for="item in apartmentList"
            :key="item.shortName"
            :label="item.fullName"
            :value="item.shortName">
          </el-option>
        </el-select>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from '../../../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../../../components/Text/TextTitle'
import ButtonConfirm from '../../../../../components/Button/ButtonConfirm'
import ButtonCancel from '../../../../../components/Button/ButtonCancel'
import {jurisdiction} from '../../../../../utils/jurisdiction'
import {api} from '../../../../api/Summary'
import {errorHandler} from '../../../../../utils/errorHandler'
import {nError, nSuccess} from '../../../../../utils/notice'
import {bus} from '../../../../../utils/bus'
import {pattern} from '../../../../../utils/regular'

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb},
  name: 'superior-role-add',
  data () {
    return {
      breadcrumb: [{
        value: '账号管理',
        name: 'upper-account-superior-account-management'
      }, {
        value: '角色管理'
      }],
      mainTitle: '修改角色',
      subheading: '修改平台账户的访问权限',
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      apartmentList: [],
      shortNameList: [],
      formData: {
        code: '',
        name: '',
        yqAppCodeList: [],
        memo: ''
      },
      yqAppCodeList: []
    }
  },
  created () {
    this.yqAppCodeList = bus.global.upperData.yqAppCodeList
    this.getApartmentList()
    this.formData.code = this.$route.params.id
    this.getRoleByCode()
  },
  methods: {
    // 获取单个角色信息
    getRoleByCode () {
      this.$axios.get(`${api.getRoleByCode}/${this.$route.params.id}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.formData.name = data.name
            if (data.yqAppCodeList) {
              data.yqAppCodeList.map(v => {
                this.shortNameList.push(v.shortName)
              })
            }
          }
        })
        .catch(errorHandler('获取角色信息失败'))
    },
    // 获取小区列表
    getApartmentList() {
      this.$axios.post(api.getCommunityList, this.yqAppCodeList)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.apartmentList = data
          }
        })
        .catch(errorHandler('获取小区列表失败'))
    },
    toRoleManagementPage () {
      this.$router.push({
        name: 'upper-account-superior-role-management'
      })
    },
    // 确认
    confirm () {
      let checkName = pattern.characterInput_24.test(this.formData.name)
      if (!this.formData.name) {
        nError('请输入角色名')
        return false
      } else {
        if (!checkName) {
          nError('角色名不允许有特殊字符或空格')
          return false
        }
      }
      if (this.shortNameList.length === 0) {
        nError('请选择角色权限')
        return false
      }
      this.formData.yqAppCodeList = []
      this.shortNameList.map(v => {
        let obj = {
          shortName: v
        }
        this.formData.yqAppCodeList.push(obj)
      })
      this.$axios.post(api.updateRole, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('修改成功')
            this.toRoleManagementPage()
          }
        })
        .catch(errorHandler('修改失败'))
    },
    cancel () {
      this.toRoleManagementPage()
    }
  }
}
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/UpperStrata/Summary/AccountManage/SuperiorRole/SuperiorRoleModify.vue